"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
var ThemeProvider_1 = require("./lib/ThemeProvider");
var TextBase_1 = require("./Text/TextBase");
exports.Tooltip = react_1.memo(function (props) {
    var title = props.title, children = props.children, enterDelay = props.enterDelay;
    var classes = useStyles().classes;
    if (title === undefined) {
        return children;
    }
    return (jsx_runtime_1.jsx(Tooltip_1.default, __assign({ title: jsx_runtime_1.jsx(TextBase_1.Text, __assign({ className: classes.root, typo: "caption" }, { children: title }), void 0), enterDelay: enterDelay }, { children: children }), void 0));
});
var useStyles = ThemeProvider_1.makeStyles({ "name": { Tooltip: exports.Tooltip } })(function (theme) { return ({
    "root": {
        "color": theme.colors.palette.light.light,
    },
}); });
//# sourceMappingURL=Tooltip.js.map